<template>
    <div class="rg-shell">
        <div class="rg-inner">

            <a href="/" class="rg-logo">
                <img :src="$platformBrand.logoUrl" :alt="$platformBrand.name" style="height:36px; width:auto;">
            </a>

            <h1 class="rg-heading">Create your account</h1>
            <p class="rg-subtext">Let's get your shop ready.</p>

            <div v-if="backendError" class="rg-alert">
                {{ backendError }}
            </div>

            <div class="form-group">
                <label class="rg-label" for="rg-name">Your name</label>
                <input
                    id="rg-name"
                    v-model="form.name"
                    type="text"
                    class="form-control form-control-lg rg-input"
                    placeholder="e.g. Jane Njeri"
                    autocomplete="name"
                    @keyup.enter="submit"
                >
                <small v-if="errors.name" class="text-danger">{{ errors.name }}</small>
            </div>

            <div class="form-group mt-4">
                <label class="rg-label">Phone number</label>
                <vue-tel-input
                    v-model="phoneRaw"
                    v-on:validate="onPhoneValidate"
                    class="rg-tel"
                ></vue-tel-input>
                <small v-if="errors.phone" class="text-danger">{{ errors.phone }}</small>
            </div>


            <button
                type="button"
                class="btn btn-dark btn-block rg-cta mt-4"
                :disabled="isLoading"
                @click="submit"
            >
                <span v-if="isLoading">
                    <span class="spinner-border spinner-border-sm mr-2" role="status"></span>
                    Sending code...
                </span>
                <span v-else>Get started <i class="bi bi-arrow-right"></i></span>
            </button>

            <p class="text-center mt-3" style="font-size:.875rem;">
                Already have an account? <a href="/login" class="text-dark font-weight-bold">Log in</a>
            </p>

        </div>
    </div>
</template>

<script>
    export default {
        name: 'RegisterBusiness',

        data() {
            return {
                form: {
                    name:         '',
                    referralCode: '',
                },
                phoneRaw:       '',
                phoneFormatted: '',
                phoneValid:     false,
                isLoading:      false,
                errors:         {},
                backendError:   '',
            };
        },

        mounted() {
            const params = new URLSearchParams(window.location.search);
            if (params.has('ref')) {
                this.form.referralCode = params.get('ref');
            }
        },

        methods: {
            onPhoneValidate(phone) {
                this.phoneValid = phone.valid;
                if (phone.valid) {
                    this.phoneFormatted = phone.number;
                    this.errors = { ...this.errors, phone: undefined };
                }
            },

            async submit() {
                this.errors      = {};
                this.backendError = '';
                let valid = true;

                if (!this.form.name.trim()) {
                    this.errors.name = 'Enter your name.';
                    valid = false;
                }
                if (!this.phoneValid) {
                    this.errors.phone = 'Enter a valid phone number.';
                    valid = false;
                }
                if (!valid) return;

                this.isLoading = true;
                try {
                    const res = await axios.post('/api/register-phone', {
                        name:        this.form.name,
                        phone:       this.phoneFormatted,
                        referralCode: this.form.referralCode,
                    });
                    if (res.data.message === 'success') {
                        window.location.href = '/otp-verification?otp-no=' + res.data.otpno;
                    }
                } catch (err) {
                    this.backendError = err.response?.data?.message
                        || 'Something went wrong. Please try again.';
                } finally {
                    this.isLoading = false;
                }
            },
        },
    };
</script>

<style scoped>
.rg-shell {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    padding: 2rem 1.25rem;
}

.rg-inner {
    width: 100%;
    max-width: 400px;
}

.rg-logo {
    display: block;
    text-align: center;
    margin-bottom: 2.5rem;
}

.rg-heading {
    font-size: 1.6rem;
    font-weight: 700;
    color: #212529;
    line-height: 1.25;
    margin-bottom: 0.5rem;
}

.rg-subtext {
    color: #6c757d;
    font-size: 0.9rem;
    margin-bottom: 2rem;
}

.rg-label {
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #6c757d;
    margin-bottom: 0.4rem;
    display: block;
}

.rg-input {
    border: none;
    border-bottom: 2px solid #dee2e6;
    border-radius: 0;
    padding-left: 0;
    background: transparent;
    font-size: 1.1rem;
    color: #212529;
    box-shadow: none !important;
    transition: border-color 0.15s ease;
}

.rg-input:focus {
    border-bottom-color: #fd4719;
    background: transparent;
    outline: none;
}

.rg-tel {
    border: none !important;
    border-bottom: 2px solid #dee2e6 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
}

.rg-tel:focus-within {
    border-bottom-color: #fd4719 !important;
}

.rg-cta {
    padding: 0.8rem 1rem;
    font-size: 1rem;
    font-weight: 600;
}

.rg-alert {
    background: #fff5f5;
    border: 1px solid #f5c6cb;
    border-radius: 6px;
    color: #842029;
    font-size: 0.875rem;
    padding: 0.65rem 1rem;
    margin-bottom: 1.25rem;
}
</style>
